import { Xmark } from 'iconoir-react';
import { TooltipButton } from '@listening/frontend/components/custom/tooltip-button';
import { cn } from '@listening/utils/react-helpers';
import * as m from '@/paraglide/messages';
import { DocumentAiContent, useDocumentInsights } from './document-ai-sidebar';
import { useReadAlongSidebarStore } from './read-along-store';

export function DocumentInsightsSidebar({
  className,
}: {
  className?: string | undefined;
}) {
  const { sidebarState, setSidebarState } = useReadAlongSidebarStore();
  const insights = useDocumentInsights();
  const open = sidebarState === 'information' && !!insights?.opened;
  return (
    <aside
      aria-label={m.read_along_ai_title()}
      aria-hidden={!open}
      inert={!open}
      className={cn(
        'absolute inset-x-0 bottom-0 z-5 flex h-[min(70%,36rem)] min-w-0 flex-col overflow-hidden rounded-t-[20px] bg-[var(--v2-page-bg)] shadow-[0_-16px_40px_-16px_rgb(0_0_0/0.25)] transition-[width,visibility] duration-350 ease-out motion-reduce:transition-none md:relative md:inset-auto md:h-auto md:shrink-0 md:rounded-none md:shadow-none',
        open
          ? 'visible border-t border-border md:w-[20rem] md:border-t-0 md:border-l lg:w-[22.75rem]'
          : 'invisible md:w-0',
        className,
      )}
    >
      <div
        className={cn(
          'relative flex h-full min-h-0 w-full flex-col transition-[opacity,transform] duration-350 ease-out motion-reduce:transition-none md:w-[20rem] md:min-w-[20rem] lg:w-[22.75rem] lg:min-w-[22.75rem]',
          open
            ? 'translate-x-0 translate-y-0 opacity-100'
            : 'translate-x-4 opacity-0 max-md:translate-x-0 max-md:translate-y-6',
        )}
      >
        <TooltipButton
          aria-label={m.common_close()}
          toolTipContent={m.common_close()}
          variant='ghost'
          size='icon'
          className='absolute top-3 right-3 z-10 size-8 rounded-full bg-[var(--v2-card-bg)] text-[var(--v2-text-muted)] transition-colors hover:text-[var(--v2-text-primary)]'
          onClick={() => setSidebarState('closed')}
        >
          <Xmark aria-hidden className='size-4' />
        </TooltipButton>
        {open && <DocumentAiContent />}
      </div>
    </aside>
  );
}
